import {
  Component,
  inject,
  Renderer2,
  signal,
  TemplateRef,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DesktopSidebarComponent } from '../../../shared/ui/layout/desktop-sidebar/desktop-sidebar.component';

import { AsideService } from '../../services/aside.service';
import { PageContextService } from '../../services/page-context.service';
import { NgComponentOutlet, NgTemplateOutlet } from '@angular/common';
import { AsideContentComponent } from '../../../shared/ui/layout/aside-content/aside-content.component';
import { ButtonComponent } from '../../../shared/ui/button/button.component';
import { TextComponent } from '../../../shared/ui/typography/text/text.component';
import { AssistantWidgetComponent } from '../../../shared/ui/assistant/assistant-widget.component';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { ToastComponent } from '../../../shared/ui/toast/toast.component';

@Component({
  selector: 'app-monitor-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    DesktopSidebarComponent,
    NgTemplateOutlet,
    NgComponentOutlet,
    AsideContentComponent,
    ButtonComponent,
    TextComponent,
    ToastComponent,
    AssistantWidgetComponent,
  ],
  templateUrl: './monitor-layout.component.html',
  styleUrls: ['./monitor-layout.component.css'],
})
export class MonitorLayoutComponent {
  protected readonly featureFlags = inject(FeatureFlagService);
  asideService = inject(AsideService);
  pageContextService = inject(PageContextService);
  private readonly renderer = inject(Renderer2);

  // --- Aside Resizing Logic ---
  asideWidth = signal(400); // Default width
  private onResizeMove!: () => void;
  private onResizeEnd!: () => void;
  protected sidebarCollapsed = signal(false);

  onResizeStart(event: MouseEvent): void {
    event.preventDefault();
    const initialX = event.clientX;
    const initialWidth = this.asideWidth();

    this.onResizeMove = this.renderer.listen(
      'document',
      'mousemove',
      (moveEvent: MouseEvent) => {
        const deltaX = moveEvent.clientX - initialX;
        let newWidth = initialWidth - deltaX;
        // Enforce min and max width
        if (newWidth < 320) newWidth = 320;
        if (newWidth > 500) newWidth = 500;
        this.asideWidth.set(newWidth);
      }
    );

    this.onResizeEnd = this.renderer.listen('document', 'mouseup', () => {
      this.onResizeMove(); // Cleanup mousemove listener
      this.onResizeEnd(); // Cleanup mouseup listener
    });
  }

  isTemplateRef(content: any): content is TemplateRef<any> {
    return content instanceof TemplateRef;
  }

  protected onSidebarToggle(): void {
    this.sidebarCollapsed.update((v) => !v);
  }
}
